import IcLogout from './IcLogout'

export default IcLogout
